import { MonetizationSummaryResponseSchema } from '@monorepo/shared/schemas/analytics'
import { get } from '@/lib/api-client'

export const monetizationService = {
  async getMonetizationSummary(fromDate: string, toDate: string) {
    const params = new URLSearchParams({ from_date: fromDate, to_date: toDate })
    return get(
      `/analytics/monetization-summary?${params}`,
      MonetizationSummaryResponseSchema
    )
  },
}
